'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setThreadPreview = exports.setFilteredSourceType = exports.setFiltered = exports.setThreadId = exports.setStatus = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _KeyPaths = require('../constants/KeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setStatus = exports.setStatus = (0, _curry2.default)(function (status, conversation) {
  return conversation.setIn(_KeyPaths.STATUS, status);
});

var setThreadId = exports.setThreadId = (0, _curry2.default)(function (threadId, conversation) {
  return conversation.setIn(_KeyPaths.THREAD_ID, threadId);
});

var setFiltered = exports.setFiltered = (0, _curry2.default)(function (threadId, conversation) {
  return conversation.setIn(_KeyPaths.FILTERED, threadId);
});

var setFilteredSourceType = exports.setFilteredSourceType = (0, _curry2.default)(function (threadId, conversation) {
  return conversation.setIn(_KeyPaths.FILTER_SOURCE, threadId);
});

var setThreadPreview = exports.setThreadPreview = (0, _setIn2.default)(_KeyPaths.THREAD_PREVIEW);